// src/services/postService.js

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const getPosts = async (instituicaoId) => {
  const response = await axios.get(`${API_URL}/instituicoes/${instituicaoId}/posts`);
  return response.data;
};

export const getPost = async (instituicaoId, postId) => {
  const response = await axios.get(`${API_URL}/instituicoes/${instituicaoId}/posts/${postId}`);
  return response.data;
};

export const createPost = async (instituicaoId, formData) => {
  const response = await axios.post(`${API_URL}/instituicoes/${instituicaoId}/posts`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updatePost = async (instituicaoId, postId, formData) => {
  const response = await axios.put(`${API_URL}/instituicoes/${instituicaoId}/posts/${postId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deletePost = async (instituicaoId, postId) => {
  const response = await axios.delete(`${API_URL}/instituicoes/${instituicaoId}/posts/${postId}`);
  return response.data;
};
